import {createApp} from 'vue'
import {createPinia} from 'pinia'
import App from './App.vue'
import router from './router'
import 'antdv-next/dist/reset.css'
import { useAuthStore } from '@stores/auth'
import { highlightDirective } from './directives/highlight'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// 全局注册高亮指令
app.directive('highlight', highlightDirective)

// 初始化认证状态
const authStore = useAuthStore(pinia)
authStore.initialize()

// 保留 AntD reset.css，但不在入口引入 JS，以减少首屏包体积

app.use(router)
app.mount('#app')

